import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';

// import config from '../../config/config';
import './ProviderSearchEmbedScreen.css';
import EmbeddedSearchBar from './EmbeddedSearchBar';
import EmbeddedLink from './EmbeddedLink';
import EmbeddedProviderCard from './EmbeddedProviderCard';

const ProviderSearchEmbedScreen = props => {
  const {
    filter, 
    onFilterChange, 
    providers, 
    highlights, 
    loading, 
    updating,
    hasQueryParams,
    style={},
  } = props;

  return (
    <>
      <Grid container padding='2em' style={{background: 'transparent'}}>
        <Grid item xs={12} md={12} lg={6}>
          <Stack 
            spacing={1} 
            sx={{
              alignItems: {xs: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
              marginBottom: {xs: '2em', sm: '2em', md: '2em', lg: '0'},
            }}
          >
            <Typography 
              variant='h1' 
              component='h1' 
              paddingTop={1.25}
              sx={{
                fontSize: '3rem', 
                fontWeight: 'bold', 
                fontFamily: 'Montserrat, sans-serif',
                textAlign: {xs: 'center', sm: 'center', md: 'center', lg: 'left'},
              }}
            >
              {
                filter?.text && providers.length && providers.length > 0
                ? 'Here\'s who we found'
                : (filter?.text && !updating && !loading ? 'No Results Found': 'Find a Physical Therapist')
              }
            </Typography>
            {filter.text && providers?.length
              ? <Typography 
                  variant='body1' 
                  sx={{
                    fontSize: '1.25rem', 
                    textAlign: {xs: 'center', sm: 'center', md: 'center', lg: 'left'},
                  }}
                >
                  Select a highly experienced MovementX physical therapist below.
              </Typography> 
              : null
            }
            {filter.text && providers?.length
            ? <Typography 
              variant='body1' 
              color='text.muted' 
              sx={{fontSize: '1rem', textAlign: {xs: 'center', sm: 'center', md: 'center', lg: 'left'},}}
            >
                Not sure who to select?{' '}
                <EmbeddedLink
                  url='https://movementx.typeform.com/provider-match'
                  bold={true}
                >
                  Click here to get matched
                </EmbeddedLink>
                {' '}or call (202) 681-1474
              </Typography>
            : null}
          </Stack>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <Stack 
            direction='row' 
            sx={{justifyContent: {xs: 'center', sm: 'center', md: 'center'}}}
          >
            <EmbeddedSearchBar filter={filter} onFilterChange={onFilterChange}/>
          </Stack>
          {/* {
            filter?.text &&
            <Grid item xs={12} sm={6}>
              <CustomSelect
                options={[{value: 'all', label: 'All'}, {value: 'in-person', label: 'In-Person'}, {value: 'virtual', label: 'Virtual'}]}
                placeholder="Filter by Condition"
                style={{minWidth: '175px'}}
                onChange={(e, val) => onFilterChange(e, {...filter, visitType: val})}
              />
            </Grid>
          } */}
        </Grid>
      </Grid>
      {
        loading || updating
        ? <Stack direction='row' justifyContent='center' padding={4}>
            <CircularProgress />
        </Stack>
        : null
      }
      <Grid container style={{background: 'transparent', marginLeft: '1em'}} paddingBottom='2em' spacing={1}>
        {
          filter.text && (providers || []).map(p => 
            <Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={p.id} paddingTop='3em'>
              <Stack direction='row' justifyContent='center'>
                <EmbeddedProviderCard 
                  key={p.id + 'card'} 
                  provider={p}
                  highlights={highlights || []}
                />
              </Stack>
            </Grid>
          )
        }
      </Grid>
        {!filter.text 
          ? <Fade timeout={{enter: 3000, exit: 0}} in={true}>
              <Stack gap={4} alignItems='center' style={{width: '100%'}} paddingTop={8}>
                <SearchIcon
                  style={{fontSize: '4rem'}}
                  sx={{color: 'text.muted'}}
                />
                <Typography 
                  variant='body1' 
                  style={{fontSize: '1.25rem'}} 
                  color='text.muted'
                >
                  Type a search in the bar above to see results.
                </Typography>
              </Stack>
            </Fade>
          : null
        }
        {
          filter.text && !loading && !updating && !providers?.length > 0
          ? <Stack direction='row' justifyContent='center'>
              <Box>
                <Stack paddingTop={6} spacing={1}>
                  <Typography style={{fontSize: '1.25rem'}}>
                    <strong>No MovementX providers matched your search</strong>
                    <span style={{fontWeight: 'normal'}}>
                      —yet.{' '}
                      But don't worry, you’ve still got options:
                    </span>
                  </Typography>
                  <ul style={{fontSize: '1.25rem'}}>
                    <li><strong>Try Telehealth</strong>: Get expert care virtually, no matter where you are. <EmbeddedLink url='https://movement-x.com/about-movementx/two-alternatives-to-traditional-pt-in-home-physical-therapy-and-telehealth/'>Learn more</EmbeddedLink>.</li>
                    <li><strong>Change Your Search</strong>: Broaden your area or update filters to explore more options.</li>
                    <li><strong>Get Help Finding a PT</strong>: Get matched by filling out <EmbeddedLink url='https://movementx.typeform.com/provider-match'>this form</EmbeddedLink> or calling our team at (202) 681-1474.</li>
                  </ul>
                  <Typography style={{fontSize: '1.25rem'}} color='text.muted' paddingTop={4}>
                    <strong>Are You a PT?</strong>
                    {' '}
                    We may be hiring in this area. Click <EmbeddedLink url='https://movement-x.com/become-a-provider/'>here</EmbeddedLink> to learn more about joining our team.
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          : null
        }
      </>
  );
};

const ProviderSearchEmbedScreenContainer = props => {
  const {hasQueryParams} = props;
  return (
    <ProviderSearchEmbedScreen {...props} />
  );
};

export default ProviderSearchEmbedScreenContainer;